export default class AutoSubmitForm {
  constructor(config) {
    this.form = config.form
  }

  init() {
    this._initListeners();
    return this;
  }

  _initListeners() {
    $(this.form).find('input').each((i, input) => {
      $(input).change(() => {
        $(this.form).submit();
      })
    })

    $(this.form).find('textarea').each((i, input) => {
      $(input).change(() => {
        $(this.form).submit();
      })
    })
  }
}
